import React from 'react';

export default () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_6010_44058)">
            <path
                d="M14 21C14 22.1046 13.1046 23 12 23C10.8954 23 10 22.1046 10 21C10 19.8954 10.8954 19 12 19C13.1046 19 14 19.8954 14 21Z"
                fill="currentColor"
            />
            <path
                d="M5.25579 8.95367L4 19H20L18.7442 8.95367C18.6622 8.29769 18.6212 7.9697 18.5582 7.68836C17.991 5.15675 15.861 3.2764 13.2786 3.02764C12.9916 3 12.6611 3 12 3C11.3389 3 11.0084 3 10.7214 3.02764C8.13898 3.2764 6.00896 5.15675 5.44181 7.68836C5.37879 7.9697 5.33779 8.29769 5.25579 8.95367Z"
                fill="var(--lm-menu-icon-primary, #E3ECF3)"
            />
            <path
                d="M10.8295 1.98178C10.9281 1.41431 11.4206 1 11.9966 1C12.5756 1 13.0698 1.41868 13.165 1.98988L13.3417 3.05117L13.141 3.19203C12.4501 3.67673 11.5294 3.67564 10.8397 3.18931L10.6438 3.05117L10.8295 1.98178Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_6010_44058">
                <rect
                    width="24"
                    height="24"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
